/**
 * This prevents the default mouse event action from happening.
 * This is useful when using anchor tags without other click handlers, names, or real linking hrefs.
 * It can be used to prevent the page from scrolling to top when supplying a '#' as the href for an anchor tag,
 * as javacript:void(0) is frowned upon by future versions of React.
 * @param e The event to block the default action on
 * @param callback A function to execute after preventing the default event action
 */
export function preventDefaultMouseEvent(e: React.MouseEvent, callback?: () => void): void {
  e.preventDefault();

  if (callback) {
    callback();
  }
}
